<template>
    <footer id="footer-content">
        <div class="footer">
            <div class="footer__banner">
                <div class="footer__banner-content">
                    <h2>
                        <router-link :to="{name: 'Медицинские осмотры по приказу 29н'}" title="Медицинские Осмотры">
                            Медицинские Осмотры
                        </router-link>
                    </h2>
                    <p>
                        <router-link :to="{name: 'Медицинские осмотры по приказу 29н'}"
                                     class="icon_small_arrow right_white"
                                     title="Читать далее">Читать далее
                        </router-link>
                    </p>
                </div>
                <div class="footer__banner-content">
                    <h2>
                        <router-link :to="{name: 'Прейскурант'}" title="Медицинские Осмотры">Прейскурант</router-link>
                    </h2>
                    <p>
                        <router-link :to="{name: 'Прейскурант'}" class="icon_small_arrow right_white"
                                     title="Читать далее">Читать далее
                        </router-link>
                    </p>
                </div>
                <div class="footer__banner-content">
                    <h2>
                        <router-link :to="{name: 'Программы годового обслуживания'}" title="Медицинские Осмотры">Годовые
                            Программы
                        </router-link>
                    </h2>
                    <p>
                        <router-link :to="{name: 'Программы годового обслуживания'}"
                                     class="icon_small_arrow right_white"
                                     title="Читать далее">Читать далее
                        </router-link>
                    </p>
                </div>

                <div class="footer__bannner-content">

                </div>
            </div>

            <div class="footer__box">
                <div class="box-item">
                    <div class="box-title">
                        ФГБУ «Поликлиника №5»
                    </div>
                    <div class="box-content">
                        <p>
                            ФГБУ Поликлиника №5 Управления делами Президента Российской Федерации на Плющихе –
                            многопрофильная клиника с широким спектром специалистов, в том числе редких врачебных
                            специальностей. Наличие большого числа отделений, собственная клинико-диагностическая
                            лаборатория, современное оборудование и высокая квалификация врачей позволяют получать
                            качественную медицинскую помощь с минимальными затратами по времени.
                        </p>

                        <p style="margin-top:-2em;">119121, Россия, г. Москва, ул. Плющиха 14</p>
                    </div>
                </div>
                <div class="box-item">
                    <div class="box-title">
                        Последние новости
                    </div>
                    <div class="box-content">
                        <ul>
                            <li :key="$index" v-for="(data, $index) in news">
                                <router-link :to="{name: 'articleDetail', params: {title: data.slug}}">{{
                                        data.title
                                    }}
                                </router-link>
                                <span class="timeago">{{ data.created }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="box-item">
                    <div class="box-title">
                        Записаться на прием по телефону
                    </div>
                    <div class="box-content">
                        <div class="contact-list">
                            <div class="contact-row">
                                <div class="contact-title">
                                    Регистратура ОМС:
                                </div>
                                <div class="contact-desc">+7 (495) 620-81-06</div>
                            </div>
                            <div class="contact-row">
                                <div class="contact-title">
                                    Регистратура ДМС:
                                </div>
                                <div class="contact-desc">+7 (495) 620-81-05</div>
                            </div>
                            <div class="contact-row">
                                <div class="contact-title">
                                    Платные мед.услуги:
                                </div>
                                <div class="contact-desc">+7 (495) 620-81-07</div>
                            </div>
                            <div class="contact-row">
                                <div class="contact-title">
                                    Стоматология:
                                </div>
                                <div class="contact-desc">+7 (499) 248-31-06</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="social-icons">
                <a href="https://vk.com/5clinic_moscow" target="_blank" class="fa fa-vk"
                   style="font-size:2.5em;padding: 0 0.3em 0 0;color:#00b6cc;padding-top:-1em;">
                </a>
                <a href="https://t.me/poliklinika5_udp" target="_blank">
                    <img src="../../assets/images/telegram.png" alt="telegram">
                </a>
                <a href="https://rutube.ru/channel/25384052/" target="_blank">
                    <img src="../../assets/images/rutube.png" alt="rutube">
                </a>
            </div>
            <div class="footer__copyright">
                <div class="copyright-text">
                    © Copyright - ФГБУ "Поликлиника №5" Управления делами Президента Российской Федерации
                </div>
                <div class="copyright-top">
                    <a @click="toTop">
                        верх
                    </a>

                    <img src="../../assets/images/icon_arrow_top_white.png" alt="top">

                </div>
            </div>
        </div>
    </footer>
</template>

<script>

import {mapGetters, mapActions} from "vuex";
import animateScrollTo from "animated-scroll-to";

export default {
    name: "footer-comp",
    data() {
        return {
            showFooter: false
        }
    },
    computed: {
        ...mapGetters(['news'])
    },
    components: {
        animateScrollTo
    },
    methods: {
        ...mapActions(['fetchHomepageNews']),
        toTop() {
            animateScrollTo(0);
        },
    },
    mounted() {
        this.fetchHomepageNews();
    }
}
</script>

<style scoped lang="scss">


footer {
    background-color: var(--skynova);
}

.footer {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;

    &__banner {
        display: flex;
        justify-content: center;
        text-align: left;

        h2 a {
            color: #FFF;
            text-decoration: none;
            font-size: 21px;
        }

        p a {
            color: #c9c9c9;
        }
    }

    &__banner-content {
        display: flex;
        flex-direction: column;
        background-color: rgb(0, 182, 204);
        width: 330px;
        padding: 20px 30px;
        -webkit-animation-timing-function: cubic-bezier(.75, 0, .25, 1);
        -webkit-animation-name: slideRight;
        justify-content: center;

        .icon_small_arrow {
            color: #fff;
        }

    }

    &__banner-content:first-child {
        background-color: rgb(0, 182, 204);
        animation-duration: 500ms;
        animation-delay: 0ms;
        transition-delay: 0ms;
        z-index: 3;
    }

    &__banner-content:nth-child(2) {
        background-color: rgb(0, 151, 181);
        animation-duration: 800ms;
        animation-delay: 250ms;
        transition-delay: 250ms;
        z-index: 2;
    }

    &__banner-content:nth-child(3) {
        background-color: rgb(0, 102, 136);
        animation-duration: 800ms;
        animation-delay: 500ms;
        transition-delay: 500ms;
        z-index: 1;
    }

    &__box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .box-item {
            width: 315px;
            margin: 10px 0;
        }

        @media screen and (max-width: 940px) {
            .box-item {
                width: 33%;
                padding: 0 15px;
            }
        }


        .box-title {
            font-size: 16px;
            color: #FFF;
            text-align: left;
        }

        .box-title::after {
            content: "";
            background-color: #00b6cc;
            width: 50px;
            height: 2px;
            display: block;
            margin-top: 10px;
        }

        .box-content {
            p {
                color: #c9c9c9;
                padding: 25px 0 28px;
                font-size: 14px;
                text-align: left;
            }

            ul {
                margin-top: 25px;
            }

            ul li {
                display: flex;
                flex-direction: column;
                text-align: left;
                margin: 5px 0;
            }

            ul li a {
                color: #D5D5D5;
                font-size: 13px;
            }

            ul li a:hover {
                text-decoration: underline;
            }

            .contact-list {
                display: flex;
                flex-direction: column;
                margin-top: 15px;
            }

            .contact-list .contact-row {
                margin: 0;
            }

            .contact-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0;
            }

            .contact-title, .contact-desc {
                font-size: 13px;
                color: #D5D5D5;
                text-align: left;
            }

            .contact-desc {
                cursor: pointer;
            }

            .contact-desc:hover {
                text-decoration: underline;
            }

            .contact-title {
                margin-right: 20px;

            }
        }

        .timeago {
            color: #00b6cc;
            font-size: 11px;
        }
    }

    &__copyright {
        display: flex;
        justify-content: space-between;

        .copyright-text, .copyright-top, .copyright-top a {
            color: #909090;
            font-size: 12px;
            cursor: pointer;
        }

        .copyright-top img {
            width: 4px;
            margin-left: 6px;
        }

    }
}

.social-icons {
    a {
        height: 32px;
        display: flex;
        align-items: center;
        font-size: 2em;
        padding: 0 0.4em 0 0;
    }

    img {
        height: 32px;
    }
}

@media screen and (max-width: 768px) {
    .footer {
        &__banner {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
        }

        &__banner-content {
            width: 65%;
            padding: 40px 30px;
        }

        &__box {
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .box-item {
                width: 65%;
            }
        }

        &__copyright {
            justify-content: center;
            flex-direction: column;
        }

        .social-icons {
            justify-content: center;
            margin-top: 10px;
        }

        .copyright-top {
            padding: 20px 0;
        }

        .copyright-top, .copyright-top a {
            color: #909090;
            font-size: 20px;
            cursor: pointer;
        }

        .copyright-top img {
            width: 7px;
            margin-left: 6px;
        }
    }
}

@media screen and (max-width: 480px) {
    .footer {

        &__banner-content {
            width: 85%;
        }

        &__box {

            .box-item {
                width: 85%;
            }
        }

    }
}


.fa-facebook-official:before {
    content: "\f230";
}

.social-icons {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
    margin-top: -20px;
}
</style>
